import { render, staticRenderFns } from "./ShippingReportModule.vue?vue&type=template&id=523de44a"
import script from "./ShippingReportModule.vue?vue&type=script&lang=js"
export * from "./ShippingReportModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports